import clsx from 'clsx'
import {useFormik} from 'formik'
import React from 'react'
import {Button, Col, Modal, Row} from 'react-bootstrap'
import * as Yup from 'yup'
import HelpBubble from '../utils/HelpBubble'

const overviewSchema = Yup.object().shape({
  firstname: Yup.string()
    .min(3, 'Minimum 3 symbols')
    .max(20, 'Maximum 20 symbols')
    .required('This field is required'),
  lastname: Yup.string()
    .min(130, 'Minimum 3 symbols')
    .max(20, 'Maximum 20 symbols')
    .required('This field is required'),
  region: Yup.string().required('This field is required'),
  city: Yup.string().required('This field is required'),
})

const initialValues = {
  firstname: 'john ',
  lastname: 'doe ',
  region: '',
  city: '',
}
type Props = {
  editModal: boolean
  handleEditModal: () => void
}
function OverviewModal({editModal, handleEditModal}: Props) {
  const formik = useFormik({
    initialValues,
    validationSchema: overviewSchema,
    onSubmit: async (values, {setStatus, setSubmitting}) => {
      try {
        //call action here
      } catch (error) {
        console.error(error)
      }
    },
  })
  return (
    <Modal show={editModal} onHide={handleEditModal} size={'lg'}>
      <Modal.Header closeButton>
        <Modal.Title>Edit your information</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form onSubmit={formik.handleSubmit} noValidate>
          <HelpBubble
            icon='/media/icons/duotune/general/gen045.svg'
            text='Please make sure that this information is accurate as it will be verfied with a
                goverment issued identification later on'
          />

          <div>
            <Row>
              <Col md={6} className='mb-1'>
                <div className='fv-row mb-10'>
                  <label className='form-label fs-6 fw-bold  '>First Name</label>

                  <input
                    {...formik.getFieldProps('firstname')}
                    placeholder='your firstname'
                    className={clsx(
                      'form-control form-control-lg form-control-solid',
                      {'is-invalid': formik.touched.firstname && formik.errors.firstname},
                      {
                        'is-valid': formik.touched.firstname && !formik.errors.firstname,
                      }
                    )}
                    type='text'
                    name='firstname'
                    autoComplete='off'
                  />
                  {formik.touched.firstname && formik.errors.firstname && (
                    <div className='fv-plugins-message-container'>
                      <span role='alert'>{formik.errors.firstname}</span>
                    </div>
                  )}
                </div>
              </Col>
              <Col md={6} className='mb-1'>
                <div className='fv-row mb-10'>
                  <label className='form-label fs-6 fw-bold'>Last Name</label>

                  <input
                    {...formik.getFieldProps('lastname')}
                    placeholder='your lastname'
                    className={clsx(
                      'form-control form-control-lg form-control-solid',
                      {'is-invalid': formik.touched.lastname && formik.errors.lastname},
                      {
                        'is-valid': formik.touched.lastname && !formik.errors.lastname,
                      }
                    )}
                    type='text'
                    name='lastname'
                    autoComplete='off'
                  />
                  {formik.touched.lastname && formik.errors.lastname && (
                    <div className='fv-plugins-message-container'>
                      <span role='alert'>{formik.errors.lastname}</span>
                    </div>
                  )}
                </div>
              </Col>
              <Col md={6} className='mb-1'>
                <div className='fv-row mb-10'>
                  <label className='form-label fs-6 fw-bold'>Region</label>

                  <select
                    className='form-select form-select-solid form-select-lg fw-bold'
                    {...formik.getFieldProps('region')}
                  >
                    <option value=''>Select a region...</option>
                    <option value='AF'>Afghanistan</option>
                    <option value='AX'>Aland Islands</option>
                    <option value='AL'>Albania</option>
                    <option value='DZ'>Algeria</option>
                    <option value='AS'>American Samoa</option>
                  </select>
                  {formik.touched.region && formik.errors.region && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>{formik.errors.region}</div>
                    </div>
                  )}
                </div>
              </Col>
              <Col md={6} className='mb-1'>
                <div className='fv-row mb-10'>
                  <label className='form-label fs-6 fw-bold'>City</label>

                  <select
                    className='form-select form-select-solid form-select-lg fw-bold'
                    {...formik.getFieldProps('city')}
                  >
                    <option value=''>Select a city...</option>
                    <option value='AF'>Afghanistan</option>
                    <option value='AX'>Aland Islands</option>
                    <option value='AL'>Albania</option>
                    <option value='DZ'>Algeria</option>
                    <option value='AS'>American Samoa</option>
                  </select>
                  {formik.touched.city && formik.errors.city && (
                    <div className='fv-plugins-message-container'>
                      <div className='fv-help-block'>{formik.errors.city}</div>
                    </div>
                  )}
                </div>
              </Col>
            </Row>
          </div>
        </form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant='secondary' onClick={handleEditModal}>
          Close
        </Button>
        <Button type='submit' disabled={formik.isSubmitting || !formik.isValid} variant='primary'>
          Save Changes
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default OverviewModal
